// src/layouts/SuperAdminLayout.tsx
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AppUserHeader, AdminSideBar } from '../components';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AuthService } from '../services';
import { useDispatch } from 'react-redux';
import { updateUser } from '../stores/authSlice';

// Same shell as the supervisor/agent: full-height column, rail + content side by
// side, only the content area scrolls, header height not hardcoded.
const PageContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflow: 'hidden',
}));

const MainContent = styled(Box)(() => ({
  display: 'flex',
  backgroundColor: '#F0F0F0',
  flex: 1,
  minHeight: 0,
}));

const ContentColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  maxWidth: 'calc(100% - 248px)',
}));

const ContentArea = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  padding: theme.spacing(2.5, 3.75),
}));

const SuperAdminLayout: React.FC = () => {
  const dispatch = useDispatch();

  const getUserData = async () => {
    try {
      const resp = await AuthService.getProfile({ add: ['userDetails'] })
      dispatch(updateUser(resp.data));
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);
  return (
    <PageContainer>
      <MainContent>
        <AdminSideBar />
        <ContentColumn>
          <AppUserHeader />
          <ContentArea>
            {<Outlet />}
          </ContentArea>
        </ContentColumn>
      </MainContent>
    </PageContainer>
  );
};

export default SuperAdminLayout;
